{"NODE_ENV":"production","RAILS_ENV":"production","TUNAG_API_BASE_URL":"https://staging4.tunag.jp/","EDUCATION_BASE_URL":"https://education.staging4.tunag.jp/"}